import { Container} from "react-bootstrap";

function Filter() {
    return (
        <div className="py-3 mb-3" style={ {background: '#2900ff30'} }>
            <Container>

            </Container>
        </div>
    );
  }
  
  export default Filter;